import { ChevronRightCircleIcon } from 'lucide-react'

import { githubDatachainUrl, studioSignUpUrl } from '@/constants/externalUrls'
import { logEventToPl } from '@/lib/plausible'
import { cn } from '@/utils'

import Link from './Link'
import { Button } from './ui/button'

const LandingActionButtons = ({
  className,
  position = `hero`
}: {
  className?: string
  position: 'hero' | 'footer'
}) => {
  return (
    <div className={cn(`flex flex-col gap-4 md:flex-row md:gap-6`, className)}>
      <Button
        variant="primary"
        rounded={`full`}
        size="xl"
        onClick={() => {
          logEventToPl(`Sign Up`, {
            'Sign Up Position': position
          })
        }}
        asChild
      >
        <Link href={studioSignUpUrl} isExternal={false}>
          Sign up
        </Link>
      </Button>

      <Button
        variant="secondary"
        rounded={`full`}
        size="xl"
        onClick={() => {
          logEventToPl(`Start for free`, {
            'Start Position': position
          })
        }}
        asChild
      >
        <Link href={githubDatachainUrl} isExternal={false}>
          Start for free
          <ChevronRightCircleIcon
            size={20}
            className="ml-1.5 animate-bounce-horizontal"
          />
        </Link>
      </Button>
    </div>
  )
}

export default LandingActionButtons
